import { render, staticRenderFns } from "./cardsContainer.vue?vue&type=template&id=19d89bbc&"
import script from "./cardsContainer.vue?vue&type=script&lang=js&"
export * from "./cardsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports